export default __webpack_public_path__ + "static/media/080_finish_good.av1.8b15b3a4.mp4";